import React, { useEffect } from 'react';
import { useGate, useStore } from 'effector-react';
import type { LibItemArticle } from '@types';
import addComponent from '@utils/addComponent';
import Title from '@components/Title';
import Button from '@components/Button';
import IconEdit from '@components/icons/IconEdit';
import useEventWatcher from '@hooks/useEventWatcher';
import ArticleModal from './ArticleModal';
import LibModal from '../layouts/LibModal';
import FooterClear from '../components/FooterClear';
import libReset from '../actions/libReset';
import { $libSelected } from '../stores/libSelected';
import LibModalNav from '../layouts/LibModalNav';
import ListArticle from './ListArticle';
import { LibItemsGate, LibMultipleGate } from '../stores/libState';
import { onArticleEditClick } from './RowArticle';
import SearchBar from '../components/SearchBar';

type Props = {
  multiple?: boolean;
  onConfirm: (result: { libItems: LibItemArticle[] }) => void;
  onRequestClose: () => void;
};

function LibArticleModal({
  multiple = false,
  onRequestClose,
  onConfirm,
}: Props) {
  useGate(LibMultipleGate, multiple);
  useEffect(() => libReset, []);
  const noSelected = !useStore($libSelected).length;

  useEventWatcher(onArticleEditClick, (item) => {
    addComponent((remove) => (
      <ArticleModal defaultData={item} onRequestClose={remove} />
    ));
    onRequestClose();
  });

  const handleAdd = () => {
    addComponent((remove) => <ArticleModal onRequestClose={remove} />);
    onRequestClose();
  };

  const handleConfirm = () => {
    const selected = $libSelected.getState();
    const items = (LibItemsGate.state.getState() as LibItemArticle[])
      .filter((x) => selected.includes(x.id))
      .sort((a, b) => selected.indexOf(a.id) - selected.indexOf(b.id));
    onConfirm({ libItems: items });
  };

  return (
    <LibModal
      onRequestClose={onRequestClose}
      header={
        <>
          <Title>文章素材库</Title>
          <SearchBar />
          <Button className="ml-auto" onClick={handleAdd}>
            <IconEdit color="#fff" />
            <span className="ml-5">新建文章</span>
          </Button>
        </>
      }
      footer={
        <>
          <Button disabled={noSelected} onClick={handleConfirm}>
            确认操作
          </Button>
          <FooterClear />
        </>
      }
      backdropZIndex={7000}
    >
      <LibModalNav
        navItems={[{ id: 'lib', name: '自定义素材' }] as const}
        selected="lib"
      />
      <ListArticle />
    </LibModal>
  );
}

export default LibArticleModal;
